export default {
  landing: {
    en: '/',
    es: '/es',
    it: '/it',
    fr: '/fr',
    de: '/de',
    tr: '/tr',
    pl: '/pl',
    pt: '/pt',
    cn: '/cn'
  },
  publishYourProperty: {
    en: '/landlords',
    es: '/es/propietarios',
    it: '/it/proprietari',
    fr: '/fr/proprietaires',
    de: '/de/fuer-den-vermieter',
    tr: '/tr/ev-sahipleri',
    pl: '/pl/wlasciciele',
    pt: '/pt/publique-a-sua-propriedade',
    cn: '/list-your-property'
  },
  howItWorks: {
    en: '/how-it-works',
    es: '/es/como-funciona',
    it: '/it/come-funziona',
    fr: '/fr/comment-fonctionne',
    de: '/de/wie-es-funktioniert',
    tr: '/tr/nasil-calisiyor',
    pl: '/pl/jak-to-dziala',
    pt: '/pt/como-funciona',
    cn: '/cn/how-it-works'
  },
  favorites: {
    en: '/favorites',
    es: '/es/favorites',
    it: '/it/favorites',
    fr: '/fr/favorites',
    de: '/de/favorites',
    tr: '/tr/favorites',
    pl: '/pl/favorites',
    pt: '/pt/favorites',
    cn: '/cn/favorites'
  },
  help: {
    de: 'https://help.spotahome.com/hc/de',
    es: 'https://help.spotahome.com/hc/es',
    fr: 'https://help.spotahome.com/hc/fr',
    it: 'https://help.spotahome.com/hc/it',
    en: 'https://help.spotahome.com/hc/en-us',
    tr: 'https://help.spotahome.com/hc/en-us',
    pl: 'https://help.spotahome.com/hc/en-us',
    pt: 'https://help.spotahome.com/hc/pt',
    cn: 'https://help.spotahome.com/hc/en-us'
  },
  myRequests: {
    en: '/my-requests',
    es: '/es/my-requests',
    it: '/it/my-requests',
    fr: '/fr/my-requests',
    de: '/de/my-requests',
    tr: '/tr/my-requests',
    pl: '/pl/my-requests',
    pt: '/pt/my-requests',
    cn: '/cn/my-requests'
  },
  myProfile: {
    en: '/my-profile',
    es: '/es/my-profile',
    it: '/it/my-profile',
    fr: '/fr/my-profile',
    de: '/de/my-profile',
    tr: '/tr/my-profile',
    pl: '/pl/my-profile',
    pt: '/pt/my-profile',
    cn: '/cn/my-profile'
  },
  myReferrals: {
    en: '/my-referrals',
    es: '/es/my-referrals',
    it: '/it/my-referrals',
    fr: '/fr/my-referrals',
    de: '/de/my-referrals',
    tr: '/tr/my-referrals',
    pl: '/pl/my-referrals',
    pt: '/pt/my-referrals',
    cn: '/cn/my-referrals'
  },
  myPayments: {
    en: '/my-payments',
    es: '/es/my-payments',
    it: '/it/my-payments',
    fr: '/fr/my-payments',
    de: '/de/my-payments',
    tr: '/tr/my-payments',
    pl: '/pl/my-payments',
    pt: '/pt/my-payments',
    cn: '/cn/my-payments'
  },
  support: {
    en: '/support',
    es: '/es/support',
    it: '/it/support',
    fr: '/fr/support',
    de: '/de/support',
    tr: '/tr/support',
    pl: '/pl/support',
    pt: '/pt/support',
    cn: '/cn/support'
  },
  searchPreferences: {
    en: '/my-alerts',
    es: '/es/my-alerts',
    it: '/it/my-alerts',
    fr: '/fr/my-alerts',
    de: '/de/my-alerts',
    tr: '/tr/my-alerts',
    pl: '/pl/my-alerts',
    pt: '/pt/my-alerts',
    cn: '/cn/my-alerts'
  },
  logout: {
    de: '/marketplace/logout',
    es: '/marketplace/logout',
    fr: '/marketplace/logout',
    it: '/marketplace/logout',
    en: '/marketplace/logout',
    tr: '/marketplace/logout',
    pl: '/marketplace/logout',
    pt: '/marketplace/logout',
    cn: '/marketplace/logout'
  },
  termsAndConditions: {
    en: '/terms-and-conditions',
    es: '/es/terminos-y-condiciones',
    it: '/it/termini-e-condizioni',
    fr: '/fr/termes-et-conditions',
    de: '/de/geschaftsbedingungen',
    tr: '/tr/sartlar-ve-kosullar',
    pl: '/terms-and-conditions',
    pt: '/terms-and-conditions',
    cn: '/cn/terms-and-conditions'
  },
  landlordPanel: {
    de: 'https://landlord.spotahome.com/de/login/',
    es: 'https://landlord.spotahome.com/es/login/',
    fr: 'https://landlord.spotahome.com/fr/login/',
    it: 'https://landlord.spotahome.com/it/login/',
    en: 'https://landlord.spotahome.com/login/',
    tr: 'https://landlord.spotahome.com/login/',
    pl: 'https://landlord.spotahome.com/login/',
    pt: 'https://landlord.spotahome.com/pt/login/',
    cn: 'https://landlord.spotahome.com/login/'
  },
  landlordSignup: {
    de: 'https://landlord.spotahome.com/de/signup/',
    es: 'https://landlord.spotahome.com/es/signup/',
    fr: 'https://landlord.spotahome.com/fr/signup/',
    it: 'https://landlord.spotahome.com/it/signup/',
    en: 'https://landlord.spotahome.com/signup/',
    tr: 'https://landlord.spotahome.com/signup/',
    pl: 'https://landlord.spotahome.com/signup/',
    pt: 'https://landlord.spotahome.com/pt/signup/',
    cn: 'https://landlord.spotahome.com/signup/'
  },
  privacyPolicies: {
    en: '/privacy-policies',
    es: '/es/politica-privacidad',
    it: '/it/privacy-policies',
    fr: '/fr/privacy-policies',
    de: '/de/privacy-policies',
    tr: '/tr/privacy-policies',
    pl: '/pl/privacy-policies',
    pt: '/pt/privacy-policies',
    cn: '/cn/privacy-policies'
  },
  googleLogin: {
    en: '/marketplace/login/google?locale=en&subscribe=no',
    es: '/marketplace/login/google?locale=es&subscribe=no',
    it: '/marketplace/login/google?locale=it&subscribe=no',
    fr: '/marketplace/login/google?locale=fr&subscribe=no',
    de: '/marketplace/login/google?locale=de&subscribe=no',
    tr: '/marketplace/login/google?locale=tr&subscribe=no',
    pl: '/marketplace/login/google?locale=pl&subscribe=no',
    pt: '/marketplace/login/google?locale=pt&subscribe=no',
    cn: '/marketplace/login/google?locale=cn&subscribe=no'
  },
  facebookLogin: {
    en: '/marketplace/login/facebook?locale=en&subscribe=no',
    es: '/marketplace/login/facebook?locale=es&subscribe=no',
    it: '/marketplace/login/facebook?locale=it&subscribe=no',
    fr: '/marketplace/login/facebook?locale=fr&subscribe=no',
    de: '/marketplace/login/facebook?locale=de&subscribe=no',
    tr: '/marketplace/login/facebook?locale=tr&subscribe=no',
    pl: '/marketplace/login/facebook?locale=pl&subscribe=no',
    pt: '/marketplace/login/facebook?locale=pt&subscribe=no',
    cn: '/marketplace/login/facebook?locale=cn&subscribe=no'
  },
  contactUs: {
    en: '/contact-us',
    es: '/es/contacto',
    it: '/it/contattaci',
    fr: '/fr/nous-contacter',
    de: '/de/kontaktieren-sie-uns',
    tr: '/tr/bize-ulasin',
    pl: '/pl/skontaktuj-sie-z-nami',
    pt: '/pt/contacte-nos',
    cn: '/cn/contact-us'
  }
};
